import { render, staticRenderFns } from "./user-terms.vue?vue&type=template&id=56ffc8da&scoped=true&"
import script from "./user-terms.vue?vue&type=script&lang=js&"
export * from "./user-terms.vue?vue&type=script&lang=js&"
import style0 from "./user-terms.vue?vue&type=style&index=0&id=56ffc8da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ffc8da",
  null
  
)

export default component.exports